import react, { useState } from "react";
import "./_PageLogin.scss";
import ItachiEyePassword from "./ItachiEyePassword/itachiEyePassword";
import { setRedirect } from "../_AdminContent/utils/_redirect";
function _PageLogin({ setIsAuthenticated }) {
  const [showPassword, setShowPassword] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showErrors, setShowErrors] = useState(false);
  const [serverError, setServerError] = useState("");

  const handleSharinganClick = () => {
    setShowPassword((prev) => !prev);
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setShowErrors(true);
    setServerError("");
    if (!username || !password) {
      return;
    }
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}api/admin/login`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ username, password }),
          credentials: "include",
        }
      );
      const data = await res.json();
      if (data.success) {
        alert(data.message || "Login Success.");
        setIsAuthenticated(true);
        setRedirect(0, 0);
        // Optionally redirect or reload
      } else {
        alert(data.message || "Login failed.");
      }
    } catch (err) {
      alert("Server error. Please try again later.");
    }
  };

  return (
    <>
      <header></header>
      <section className="ad-login-container">
        <div className="ad-login-wrapper">
          <span>ADMIN LOGIN</span>
          <div className="adl-input-wrapper">
            <label>USERNAME:</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
            {showErrors && !username && (
              <span className="error">username required!</span>
            )}
          </div>
          <div className="adl-input-wrapper">
            <label>PASSWORD:</label>
            <input
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <ItachiEyePassword onLoginClick={handleSharinganClick} />

            <span className="error">
              {showErrors && !password && "password required!"}
            </span>
          </div>
          <button onClick={handleLogin}>LOGIN</button>
        </div>
      </section>
    </>
  );
}

export default _PageLogin;
